import React, { Component } from 'react';

class Staff extends Component {
  getStaff() {
    let staffs = this.props.staff.map((staff) =>
      <p className="no-margin staffp" key={staff.id}><span className="staff-position">{staff.position}</span>: <span className="staff-name">{staff.first_name} {staff.last_name}</span></p>
    );
    return staffs;
  }
  render() {
    if(this.props.staff.length > 0){
      return (
        <div>
          <div className="section-title">Team Staff</div>
          <div className="staffBox">
            {this.getStaff()}
          </div>
        </div>
      );
    } else {
      return (
        <div className="staffBox spacer-top10">
        </div>
      );
    }
  }
}

export default Staff;
